import React from 'react'
import PageUnderConstruction from './PageUnderConstruction'

export default function Leaderboard() {
    return (
        <div data-testid = "leaderboard" className = "component-container">
            Leaderboard
            <PageUnderConstruction />
        </div> 
    )
}
